const API = process.env.NODE_ENV === 'development' ? 'https://api.52c.ru' : 'https://api.52c.ru';

const UPLOADS = `${API}/uploads`;

const FILES = `${API}/files`;

const IMAGES = `${API}/images`;

const TURNSTILE_KEY = process.env.NODE_ENV === 'development' ? '1x00000000000000000000AA' : '0x4AAAAAAAJW7SLpa5ieKuw2';

const SETTINGS_APP = {
    project_format: 'RU',
    mask: {
        'RU': {
            'account': ['+', 7,'(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
            'default': ['+', /(7|8)/,'(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
            'placeholder': '+7(999)999-9999',
        },
        'UZ': {
            'account': ['+', 9, 9, 8, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
            'default': ['+', 9, 9, 8, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
            'placeholder': '+998 99 999 99 99'
        },
    },
    currency: {
        'RU': {
            'label': '₽',
            'value': 'rub',
        },
        'UZ': {
            'label': 'UZS',
            'value': 'uzs',
        },
    }
};

export {
    API,
    UPLOADS,
    FILES,
    IMAGES,
    TURNSTILE_KEY,
    SETTINGS_APP
}